import { createApp, Transition } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import { defineRule, Form, Field, ErrorMessage } from 'vee-validate';
import { Multiselect } from 'vue-multiselect';
import VueDatePicker from '@vuepic/vue-datepicker';
import './style.css'

import Boolean from './components/shared/forms/Boolean.vue'
import Number from './components/shared/forms/Number.vue'
import Radios from './components/shared/forms/Radios.vue'
import TextInput from './components/shared/forms/TextInput.vue'
import Checkbox from './components/shared/forms/Checkbox.vue'
import Checkboxes from './components/shared/forms/Checkboxes.vue'
import Percentages from './components/shared/forms/Percentages.vue'
import DateInput from './components/shared/forms/DateInput.vue'

import QuoteJourney from './QuoteJourney.vue'


// Regsiter all validators availbale for veevalidate
const r = { ...VeeValidateRules.default, ...customRules }
Object.keys(r).forEach(rule => {
    defineRule(rule, r[rule])
});

const pinia = createPinia();
const app = createApp(QuoteJourney);

app.component('VForm', Form);
app.component('VField', Field);
app.component('ErrorMessage', ErrorMessage);
app.component('Transition', Transition);
app.component('Multiselect', Multiselect);
app.component('Datepicker', VueDatePicker);

app.component('Boolean', Boolean);
app.component('Number', Number);
app.component('Radios', Radios);
app.component('TextInput', TextInput);
app.component('Checkbox', Checkbox);
app.component('Checkboxes', Checkboxes);
app.component('Percentages', Percentages);
app.component('DateInput', DateInput);

app.use(pinia);
app.use(router);
app.mount('#quote-journey');

document.addEventListener('DOMContentLoaded', displayLoader('hide'), false);
